import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Pageable, UsersService } from '@src/api/auth';
import { BaseTablePageComponent } from '@src/app/components';
import { TableModule } from '@src/app/modules/table';
import { UserUI } from '@src/app/types';

import { StatusComponent } from '../status';

import { TABLE_NAME } from './constants';

@Component({
  selector: 'add-form',
  standalone: true,
  imports: [TableModule, StatusComponent],
  templateUrl: './add-form.component.html',
  styleUrl: './add-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddFormComponent extends BaseTablePageComponent<
  UserUI,
  UserUI,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined
> {
  @Input() excludeUUIDs: string[] = [];
  @Output() valueChange = new EventEmitter<UserUI[]>();
  private readonly usersService = inject(UsersService);

  constructor() {
    super({
      useQueryParams: false,
      tableName: TABLE_NAME,
      dataKey: 'id',
      toolbarOptions: {
        visible: false,
      },
      rowMenuOptions: {
        visible: false,
      },
      columnOptions: {
        sorting: true,
      },
      selecting: true,
      currentPageReportTemplate: 'Отображено с {first} по {last} из {totalRecords} пользователей',
      columns: ['isEnabled', 'firstName', 'surName', 'lastName', 'position'],
      excludeColumns: ['username', 'phone', 'email', 'role', 'createdAt', 'updatedAt', 'loginAt'],
      sortField: 'id',
    });
  }

  getRequestObservable(pageable?: Pageable, filter?: { [key: string]: Array<any> }) {
    if (this.excludeUUIDs.length) {
      const uuidFilter = this.excludeUUIDs.map(uuid => {
        return {
          value: uuid,
          matchMode: 'notEquals',
          operator: 'and',
        };
      });

      if (!filter) {
        filter = {};
      }

      filter['uuid'] = uuidFilter;

      return this.usersService.getUsersByFilter(pageable, filter);
    } else {
      return this.usersService.getUsersByFilter(pageable);
    }
  }

  onSelectionChanged(value: UserUI[]) {
    this.valueChange.emit(value);
  }
}
